import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import { hasStyleCopyPasteBehaviors, isTable } from '../objects/guards';
import Shortcut from '../utils/Shortcut';

class ToolCopyStyle extends Tool {
  static toolName = 'Copy style';

  static shortcut = new Shortcut('Cmd+Option+C');

  static action({ controller, selection }: IToolActionInput) {
    controller.actionCopyStyle(selection.firstObject());
  }

  static available({ selection, controller }: IToolAvailableInput) {
    const obj = selection?.firstObject();

    // Not available if obj is table with multiple selected cells
    if (!obj || (isTable(obj) && obj.hasMultipleSelectedCells())) {
      return false;
    }

    return (
      super.available({ selection, controller }) &&
      obj &&
      selection?.getObjects()?.length === 1 &&
      hasStyleCopyPasteBehaviors(obj) &&
      obj.canCopyStyles()
    );
  }

  static enabled({ selection }: IToolEnabledInput) {
    const objects = selection?.getObjects();
    if (objects?.length !== 1) {
      return false;
    }
    const obj = objects[0];

    return hasStyleCopyPasteBehaviors(obj) && obj.canCopyStyles();
  }

  static buttonComponent() {
    return simpleToolButton(ToolCopyStyle, 'fa-regular fa-pallete', {
      stopPropagation: true,
    });
  }
}

export default ToolCopyStyle;
